(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const dialog = document.getElementById('cs-discount-popup');
      if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;
      const key = dialog.dataset.storageKey;
      const day = 24 * 60 * 60 * 1000;
      try {
        const lastShown = Number(window.localStorage.getItem(key));
        if (lastShown && Date.now() - lastShown < 7 * day) return;
      } catch (_) {}
      let opened = false;
      const open = () => {
        if (opened || dialog.open) return;
        opened = true;
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onExit);
        dialog.showModal();
        try { window.localStorage.setItem(key, String(Date.now())); } catch (_) {}
      };
      const onScroll = () => { if (window.scrollY >= window.innerHeight * 1.25) open(); };
      const onExit = (event) => { if (event.clientY <= 0 && !event.relatedTarget) open(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('mouseout', onExit);
      dialog.querySelector('[data-cs-discount-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halloween-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const dialog = document.getElementById('cs-halloween-popup');
      if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;
      const expiresAt = Number(dialog.dataset.expiresAt);
      if (Date.now() >= expiresAt) return;
      const key = dialog.dataset.storageKey;
      try {
        const last = Number(window.localStorage.getItem(key));
        if (last && Date.now() - last < 86400000) return;
      } catch (_) {}
      const readyAt = Date.now();
      let shown = false;
      let previousFocus;
      const onScroll = () => {
        if (Date.now() - readyAt >= 3000 && window.scrollY >= window.innerHeight * 0.75) open();
      };
      const cleanup = () => window.removeEventListener('scroll', onScroll);
      const open = () => {
        if (shown || dialog.open || Date.now() >= expiresAt) return;
        const otherDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(element => element !== dialog && element.getClientRects().length > 0);
        if (otherDialog) return;
        previousFocus = document.activeElement;
        shown = true;
        cleanup();
        dialog.showModal();
        document.documentElement.classList.add('cs-halloween-open');
        try { window.localStorage.setItem(key, String(Date.now())); } catch (_) {}
      };
      dialog.querySelector('[data-cs-halloween-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cs-halloween-open');
        previousFocus?.focus?.({ preventScroll: true });
      });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.setTimeout(open, 6500);
      window.setTimeout(open, 16000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
